// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1407b060","589":"09b332dc"}[chunkId] + ".chunk.js";
};